import { render, staticRenderFns } from "./RegApplicationFormFields.vue?vue&type=template&id=f209913c&scoped=true"
import script from "./RegApplicationFormFields.vue?vue&type=script&lang=js"
export * from "./RegApplicationFormFields.vue?vue&type=script&lang=js"
import style0 from "./RegApplicationFormFields.vue?vue&type=style&index=0&id=f209913c&prod&scoped=true&lang=css"
import style1 from "./RegApplicationFormFields.vue?vue&type=style&index=1&id=f209913c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f209913c",
  null
  
)

export default component.exports